<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('awards') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_award')"
        :loading="savingAward"
        :saving="savingAward"
        @click="initAward"
      />
    </div>

    <BaseTableLoader :loading="!awards">
      <AwardsTable
        :items="awards"
        :pagination="awardsPagination"
        :loading="loadingAwards"
        @edit="$router.push({ name: 'editAward', params: { id: $event.id } })"
        @update:page="onPageChange"
        @delete="deleteAward"
        @click:text="viewDescription"
      />
    </BaseTableLoader>
    <router-view @click:close="closeDialog" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import BaseTableLoader from '../../components/base/BaseTableLoader';
import AwardsTable from '../../components/AwardsTable';

export default {
  name: 'Awards',

  components: { AwardsTable, BaseTableLoader, BasePrimaryActionButton },

  created() {
    if (!this.awards) {
      this.fetchAwards(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.awardsFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'awards'
    ) {
      this.fetchAwards(to.query);
    }
    next();
  },

  computed: mapState('awards', [
    'awards',
    'awardsPagination',
    'awardsFilterParams',
    'loadingAwards',
    'savingAward',
  ]),

  methods: {
    ...mapActions('awards', ['fetchAwards', 'storeAwards', 'deleteAward']),

    initAward() {
      this.storeAwards().then((res) => {
        this.$router.push({ name: 'editAward', params: { id: res.data.id } });
      });
    },

    onPageChange(page) {
      const query = { ...this.awardsFilterParams, page };
      this.$router.push({ name: 'awards', query });
    },

    viewDescription(event) {
      this.$router.push({
        name: 'awards/text',
        params: { id: event.id },
      });
    },

    closeDialog() {
      this.$router.push({ name: 'awards', query: this.awardsFilterParams });
    },
  },
};
</script>

<style scoped></style>
